import useActivePosition from 'hooks/models/position/useActivePosition';
import { canManagePerDiemForAnyone } from 'utils/positionUtils';

export default function useCanManagePerDiemForAnyone() {
  const activePosition = useActivePosition();
  return canManagePerDiemForAnyone(activePosition);
}
